import $ from 'jquery';

export const initializePhoneNumberWidget = () => {
    $('.phonenumber').phoneNumber({
        validated: (phone, $parent) => {
            const $selector = $parent.find('select.country');
            if (phone) {
                $selector
                    .val(phone.regionCode.toLowerCase())
                    .trigger('change')
                    .selectmenu('refresh');

                $selector
                    .selectmenu('instance')
                    .button
                    .show();
            } else {
                $selector
                    .selectmenu('instance')
                    .button
                    .hide();
            }
        },
    });
};
